import type {
	FeatureFlagBridge,
	FeatureValueType,
} from '@innovyze/inno-map/wrappers/useFeatureFlag';
import { useSelectFeatures } from '@innovyze/stylovyze';
import { useCallback, useMemo } from 'react';

export function useFeatureFlagBridge(): FeatureFlagBridge {
	const features = useSelectFeatures();

	const getVariation = useCallback(
		(feature: string) => {
			const value = features[feature];
			return value as FeatureValueType;
		},
		[features],
	);

	return useMemo(() => ({ getVariation }), [getVariation]);
}
